import { Component, OnInit } from '@angular/core';
import { TempArchGoalsService } from '../temp-arch-goals.service';
import { Router } from "@angular/router";

@Component({
  selector: 'app-temp-arch-goals',
  templateUrl: './temp-arch-goals.component.html',
  styleUrls: ['./temp-arch-goals.component.css']
})
export class TempArchGoalsComponent implements OnInit {

  goals: any[] = [];
  page = 1;
  pageSize = 20;

  constructor(
    private tempArchGoalsService: TempArchGoalsService,
    private router: Router,
  ) {
    this.tempArchGoalsService.tempArchGoals
      .subscribe(goals => this.goals = goals);
    this.page = this.tempArchGoalsService.page;
  }

  ngOnInit(): void {
  }

  public onPageChange(pageNum: number): void {
    this.tempArchGoalsService.page = pageNum;
  }

  add(): void {
    this.router.navigateByUrl('backstage/temp-arch-goals/create');
  }

  getStatusText(goal: any): string {
    var now = new Date();
    if (now > goal.end.toDate()) {
      return '已結束';
    } else if (now <= goal.end.toDate() && now > goal.start.toDate()) {
      return '進行中';
    } else {
      return '即將開始';
    }
  }

}
